import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
} from './taskboard.action';
import { Taskboard, CommunicationCategory, CommunicationStatus, CommunicationFile } from './taskboard.model';
import { Member } from '../Member/member.model';

export interface TaskboardRecordsState {
    listData: any[];
    singleData: Taskboard;
    loading: boolean;
    error: any;
    total: number;
    statuses: CommunicationStatus[];
    categories: CommunicationCategory[];
    members: Member[];
    dummyId: string;
    files: CommunicationFile[];
}

export const initialState: TaskboardRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    statuses: [],
    categories: [],
    members: [],
    dummyId: "",
    files: []
};

export const taskboardReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),

    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { dummyId, singleData, files, statuses, categories, members }) => {
        return { ...state, dummyId, singleData, files, statuses, categories, members, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
);